<template>
  <shared-product-edit :product="product" :images="images">
    <div slot="body-bottom-left" v-if="availableMatch">
      <panel title="Produto selecionado no match" class="blue-panel">
        <panel>
          <div class="l-row">
            <div class="l-col-1@md img-product">
              <div class="l-col-4@md">
                <circle-chart :percent="availableMatch.percent" :color="percentColor(availableMatch.percent)">
                  {{ availableMatch.percent }}%
                </circle-chart>
              </div>
            </div>
            <div class="l-col-2@md u-textCenter">
              <img :src="availableMatch.image" class="product-availablematch-img">
            </div>
            <div class="l-col-9@md">
              <div class="l-row">
                <div class="l-col-12@md available-title">{{ availableMatch.title }}</div>
                <div class="l-col-3@md">
                  <span><strong>EAN:</strong> {{ availableMatch.ean }}</span>
                </div>
                <div class="l-col-3@md">
                  <span><strong>Marca:</strong> {{ availableMatch.brand }}</span>
                </div>
                <div class="l-col-3@md" v-for="attribute in availableMatch.attributes" :key="attribute">
                  <span><strong>{{ attribute.label }}:</strong> {{ formatAttribute(attribute.value) }}</span>
                </div>
              </div>
            </div>
          </div>
        </panel>
      </panel>
    </div>
  </shared-product-edit>
</template>

<script>
  import Panel from '@/components/template/Panel'
  import SharedProductEdit from '@/components/marketplace/shared/ProductEdit'

  export default {
    props: {
      product: {
        type: Object,
        required: true
      }
    },
    methods: {
      formatAttribute (value) {
        if (value.indexOf('|') !== -1) {
          value = value.replace(/\|/g, ', ')
        }

        return value
      },
      formatProduct () {
        return {
          description: this.product.description,
          height: parseFloat(this.product.height),
          width: parseFloat(this.product.width),
          length: parseFloat(this.product.length)
        }
      },
      percentColor (percent) {
        if (percent < 33) {
          return '#d62728'
        }

        if (percent >= 33 && percent < 67) {
          return '#FFA500'
        }

        return '#4f8a10'
      }
    },
    computed: {
      images () {
        return this.product.images
      },
      availableMatch () {
        if (!this.product.selectedMatchSku) {
          return null
        }

        return this.product.availableMatches.find(availableMatch => availableMatch.sku === this.product.selectedMatchSku)
      }
    },
    components: {
      SharedProductEdit,
      Panel
    }
  }
</script>

<style lang="sass" scoped>
  .margin
    margin-top: 10px

  .product-availablematch-img
    max-width: 75px
</style>



// WEBPACK FOOTER //
// ProductEdit.vue?b1708c60